import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export function CountUp({ to, duration = 1100 }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      setN(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);
  return n.toLocaleString();
}

export default function IntroStats({ stats }) {
  return (
    <motion.div
      data-testid="demo-intro-stats"
      className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-10"
      initial="hidden"
      animate="show"
      variants={{ show: { transition: { staggerChildren: 0.12 } } }}
    >
      {stats.map((s, i) => (
        <motion.div
          key={i}
          data-testid={`demo-intro-stat-${i}`}
          variants={{ hidden: { opacity: 0, y: 24, scale: 0.9 }, show: { opacity: 1, y: 0, scale: 1 } }}
          transition={{ type: "spring", stiffness: 160, damping: 16 }}
          className="text-center"
        >
          <div className="font-mono text-3xl sm:text-4xl font-bold bg-gradient-to-r from-emerald-300 to-cyan-300 bg-clip-text text-transparent tabular-nums">
            {s.prefix}<CountUp to={s.value} />{s.suffix}
          </div>
          <div className="mt-1 font-mono text-[10px] tracking-[0.22em] uppercase text-slate-400">{s.label}</div>
        </motion.div>
      ))}
    </motion.div>
  );
}
